import React from "react";
import { TableRow } from '@material-ui/core'
import { useIntl } from 'react-intl'
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord'
import CheckIcon from '@material-ui/icons/Check'
import LinkIcon from '@material-ui/icons/Link'
import { StyledTableCellProps as StyledTableCell } from '../../commons/utils/TableStyles.js'
import Timezone from '../../commons/timezone/Timezone.js'

// Tokens del theme (ver vec-3444-centro-notificaciones.md §5.3.1): $primary y $body-color,
// no los colores del mockup de Jira.
const COLOR_NO_LEIDA = '#666EE8'
const COLOR_LEIDA = '#6B6F82'

const CentroNotificacionesGridRow = (props) => {
	const intl = useIntl()
	const notificacion = props.notificacion

	const tituloNoLeidaLabel = intl.formatMessage({ id: 'centroNotificaciones.grid.estado_no_leida', defaultMessage: 'No leída' })
	const tituloLeidaLabel = intl.formatMessage({ id: 'centroNotificaciones.grid.estado_leida', defaultMessage: 'Leída' })

	return (
		<TableRow
			hover
			style={{ cursor: 'pointer' }}
			onClick={() => props.onRowClick(notificacion)}
		>
			<StyledTableCell align="center" style={{ width: "60px" }}>
				{notificacion.leida
					? <CheckIcon style={{ color: COLOR_LEIDA }} titleAccess={tituloLeidaLabel} />
					: <FiberManualRecordIcon style={{ color: COLOR_NO_LEIDA }} titleAccess={tituloNoLeidaLabel} />
				}
			</StyledTableCell>
			<StyledTableCell align="left" style={{ fontWeight: notificacion.leida ? 400 : 600 }}>
				{notificacion.titulo}
			</StyledTableCell>
			<StyledTableCell align="left">
				{notificacion.cuerpo}
			</StyledTableCell>
			<StyledTableCell align="center" style={{ width: "60px" }}>
				{notificacion.url ? <LinkIcon style={{ color: COLOR_LEIDA }} /> : '—'}
			</StyledTableCell>
			<StyledTableCell align="left" style={{ width: "180px" }}>
				{Timezone.getDateForClient(notificacion.fecha_hora, 'YYYY-MM-DD HH:mm:ss', 'DD/MM/YYYY HH:mm')}
			</StyledTableCell>
		</TableRow>
	)
}

export default CentroNotificacionesGridRow
